import { Box, Button, Flex, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { deleteFAQ, deleteFAQtoURL } from "../../api/ApiConfigWeb";

const DeleteFAQ = ({
  listUrl,
  listId,
  onSuccess,
}: {
  listUrl?: string[];
  listId?: number[];
  onSuccess: any;
}) => {
  return (
    <Box>
      <Text fw={"bold"} size="20px" mt={10}>
        Bạn có chắc muốn xóa các FAQ này ?
      </Text>
      <Flex justify={"end"} mt={10}>
        <Button
          color="red"
          leftSection={<IconCheck size={16} />}
          onClick={() => {
            if (listUrl) {
              deleteFAQtoURL(listUrl ?? [], onSuccess);
            } else {
              deleteFAQ(listId ?? [], onSuccess);
            }
          }}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default DeleteFAQ;
